export default __webpack_public_path__ + "static/structural2-05e60aa925850478c5e99f99483515d2.png";